import { FaInstagram, FaFacebookF, FaYoutube, FaXTwitter } from "react-icons/fa6";
// import { useStrapiConstants } from "../../../hooks/useStrapiConstants";
import { useStrapiConstants } from "../../../contexts/StrapiConstantsContext";
import Loading from "../Loading";
const SocialIcons = () => {
    const { loaded, socialLink } = useStrapiConstants();
    if (!loaded) return <Loading />;
    return (
        <div style={styles.container}>
            {socialLink.twitter && (
                <a href={socialLink.twitter} target="_blank" rel="noopener noreferrer">
                    <FaXTwitter style={styles.icon} />
                </a>
            )}

            {socialLink.youtube && (
                <a href={socialLink.youtube} target="_blank" rel="noopener noreferrer">
                    <FaYoutube style={styles.icon} />
                </a>
            )}

            {socialLink.instagram && (
                <a href={socialLink.instagram} target="_blank" rel="noopener noreferrer">
                    <FaInstagram style={styles.icon} />
                </a>
            )}

            {socialLink.facebook && (
                <a href={socialLink.facebook} target="_blank" rel="noopener noreferrer">
                    <FaFacebookF style={styles.icon} />
                </a>
            )}

        </div>
    );
};


const styles = {
    container: {
        margin: '0 auto', // ✅ Centers the container
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center', // ✅ Keeps columns spaced apart
        //alignItems: 'center',
        width: '100%', // Optional but helps responsiveness
        padding: '0.5rem 0 0.5rem 0',
        gap: '1rem'
    },
    icon: {
        fontSize: "2.5rem",
        color: "#000",
        border: "1px solid #ddd",
        borderRadius: "50%",
        padding: "0.5rem",
        transition: "all 0.3s ease",
        cursor: "pointer",
    },
};

export default SocialIcons;